<template>
  <div>
    <div class="page-head">
      <div>
        <el-button type="success" size="small" @click="onCreate">手工录入订单</el-button>
        <el-button type="primary" size="small" @click="onBatchCreate">批量导入订单</el-button>
      </div>
    </div>
    <list row-key="id" ref="list" unit="订单" :page="page" :query-params="params" :show-checkbox="showCheckbox"
      :show-query="showQuery" :get-data-func="getDataFunc" :toolbar-left="16" :toolbar-right="8">
      <div slot="toolbar">
        <div class="toolbar">
          <el-radio-group v-model="dataType" size="mini" @change="onTypeChange" style="margin-right: 10px;">
            <el-radio-button :label="0">未打印（{{ countInfo.noPrint }}）</el-radio-button>
            <el-radio-button :label="1">已打印（{{ countInfo.isPrint }}）</el-radio-button>
          </el-radio-group>
          <el-button type="primary" plain @click="openPrint()">批量打印</el-button>
          <el-button type="primary" plain @click="batchRecycleNumber()">批量回收单号</el-button>
          <el-button type="primary" plain @click="batchDelete()">批量删除</el-button>
          <el-button type="primary" plain @click="onExport">导出订单</el-button>
        </div>
      </div>
      <template slot="query">
        <el-form-item label="店铺名称">
          <el-select v-model="mallId" @change="onMallChange" placeholder="请选择">
            <el-option v-for="(i, k) in mallList" :key="k" :label="i.mallName" :value="i.mallId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="快递公司">
          <el-select v-model="params.快递公司" placeholder="请选择" clearable>
            <el-option v-for="(i, k) in companiesList" :key="k" :label="i.logisticsCompany" :value="i.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="快递单号">
          <el-input v-model="params.快递单号" placeholder="请输入快递单号" clearable />
        </el-form-item>
        <el-form-item label="订单号">
          <el-input v-model="params.orderNumber" placeholder="请输入订单号" clearable />
        </el-form-item>
        <el-form-item label="收件人">
          <el-input v-model="params.收件人" placeholder="请输入收件人" clearable />
        </el-form-item>
        <el-form-item label="联系方式">
          <el-input v-model="params.联系方式" placeholder="请输入联系方式" clearable />
        </el-form-item>
        <el-form-item label="订单类型">
          <el-select v-model="params.订单类型" placeholder="请选择" clearable>
            <el-option label="匹配订单" :value="0"></el-option>
            <el-option label="自定义订单" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="地区选择">
          <address-select v-model="params.地区选择" :placeholder="'请选择地区'" @change="onAddressSelect" />
        </el-form-item>
        <el-form-item label="创建时间">
          <range-picker :date="[params.startDate, params.endDate]"
            @change="x => { params.startDate = x.Start; params.endDate = x.End; }" />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="additional.orderNumber" label="订单号" min-width="280px" />
        <el-table-column prop="mall.mallName" label="店铺" min-width="220px" />
        <el-table-column prop="type" label="订单类型" width="110px" align="center">
          <template slot-scope="{row:{additional}}">
            <span v-if="additional.manualOrderType == 10">自定义订单</span>
            <span v-if="additional.manualOrderType == 20">匹配订单</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" min-width="180px" />
        <el-table-column prop="isPrint" label="状态" width="70px" align="center">
          <template slot-scope="{row}">
            <span v-if="row.isPrint == 0">未打印</span>
            <span v-if="row.isPrint == 1">已打印</span>
          </template>
        </el-table-column>
        <el-table-column label="收件信息" min-width="300px" placeholder>
          <template slot-scope="{row:{receiverAddress}}">
            <template v-if="receiverAddress">
              <span>{{ receiverAddress.fullName }}，{{ receiverAddress.mobilePhone }}</span>
              <span>，{{ receiverAddress.province }}/{{ receiverAddress.city }}/{{ receiverAddress.district }}/</span>
              <span v-if="receiverAddress.street">{{ receiverAddress.street }}/</span>
              <span>{{ receiverAddress.detailAddress }}</span>
            </template>
            <template v-else>--</template>
          </template>
        </el-table-column>
        <el-table-column label="发件人信息" min-width="200px" placeholder>
          <template slot-scope="{row:{senderAddress}}">
            <template v-if="senderAddress">
              <span>{{ senderAddress.fullName }}，{{ senderAddress.mobilePhone }}</span>
              <span>，{{ senderAddress.province }}/{{ senderAddress.city }}/{{ senderAddress.district }}/</span>
              <span v-if="senderAddress.street">{{ senderAddress.street }}/</span>
              <span>{{ senderAddress.detailAddress }}</span>
            </template>
            <template v-else>--</template>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" min-width="300px" placeholder>
          <template slot-scope="{row}" v-if="row.items.length > 0">{{ row.items[0].goodsName }}</template>
        </el-table-column>
        <el-table-column label="商品数量" min-width="100px">
          <template slot-scope="{row}" v-if="row.items.length > 0">{{ row.items[0].goodsCount }}</template>
        </el-table-column>
        <el-table-column label="重量（kg）" min-width="100px">
          <template slot-scope="{row}" v-if="row.items.length > 0">{{ row.items[0].goodsWeight }}</template>
        </el-table-column>
        <el-table-column prop="note" label="备注" min-width="300px" placeholder />
        <el-table-column label="快递信息" min-width="200px">
          <template slot-scope="{row}">
            <template v-if="row.Field8 && row.Field8.length > 0">
              <div v-for="(i1, k1) in row.Field8" :key="k1">
                <div>{{ i1.Field8_1 }}：</div>
                <div v-for="(i2, k2) in i1.Field8_2" :key="k2">{{ i2.Field8_2_1 }}</div>
              </div>
              <div><el-button type="text">复制</el-button></div>
            </template>
            <span v-else>- -</span>
          </template>
        </el-table-column>
        <el-table-column label="单号状态" min-width="120px">
          <template slot-scope="{row}">
            <span v-if="row.Field9 == 0">- -</span>
            <span v-if="row.Field9 == 1">取号失败</span>
            <span v-if="row.Field9 == 2">正常</span>
            <span v-if="row.Field9 == 3">已回收</span>
            <span v-if="row.Field9 == 4">部分回收</span>
          </template>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <print-dialog ref="printDialog" />
    <edit-dialog ref="editDialog" @show-print="showPrint" />
    <batch-insert-dialog ref="batchInsertDialog" @close-saved="reload" />
    <recycle-msg-dialog ref="recycleMsgDialog" @closed="reload" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import batchInsertDialog from "./batchInsertDialog";
import recycleMsgDialog from "./recycleMsgDialog";

export default {
  mixins: [listMixin],
  components: {
    list,
    batchInsertDialog,
    recycleMsgDialog,
    'editDialog': () => {
      return new Promise((resolve, reject) => {
        var sys_type = localStorage.getItem("sys_type");
        console.log("component", sys_type);
        resolve(import('./' + sys_type + '/editDialog'));
      })
    },
    'printDialog': () => {
      return new Promise((resolve, reject) => {
        var sys_type = localStorage.getItem("sys_type");
        console.log("component", sys_type);
        resolve(import('./' + sys_type + '/printDialog'))
      })
    },
  },
  data() {
    return {
      pddApi: {
        order: require("@/api/pdd/order").default,
        logistics: require('@/api/pdd/logistics').default,
      },
      dataType: 0, //未打印/已打印
      sysType: "",
      mallId: "", //店铺Token
      params: {
        快递公司: "",
        快递单号: "",
        orderNumber: "",
        收件人: "",
        联系方式: "",
        订单类型: null,
        地区选择: null,
        startDate: this.$commonJs.getDayAgo(),
        endDate: this.$commonJs.getToday()
      },
      companiesList: [],
      countInfo: {
        noPrint: 0,
        isPrint: 0,
        isLock: 0
      }
    };
  },
  created() {
    this.sysType = localStorage.getItem("sys_type");
    var user_info = localStorage.getItem("user-info");
    if (user_info) {
      let user = JSON.parse(user_info);
      let malls = this.$store.state.user.mallList.filter(x => x.day >= 0 && x.mallId == user.mallId);
      if (malls.length > 0) this.mallId = malls[0].mallId;
    }
    // this.getCompanies();
  },
  computed: {
    mallList() {
      return this.$store.state.user.mallList.filter(x => x.day >= 0);
    }
  },
  mounted() { },
  methods: {
    onMallChange() {
      this.params.快递公司 = "";
      this.companiesList = [];
      this.getCompanies();
    },
    getCompanies() {
      return new Promise((resolve, reject) => {
        this[this.sysType + "Api"].logistics.companies(this.mallId).then(res => {
          if (!res.errorCode) this.companiesList = res.data;
          resolve();
        }).catch((err) => {
          resolve()
        })
      })
    },
    getManualCountInfo() {
      return new Promise((resolve, reject) => {
        this[this.sysType + "Api"].order.getManualCountInfo(this.mallId).then(res => {
          if (res) {
            this.countInfo.noPrint = res.noPrint;
            this.countInfo.isPrint = res.isPrint;
            this.countInfo.isLock = res.isLock;
          }
          resolve();
        }).catch((err) => {
          resolve()
        })
      })
    },
    getDataFunc(params) {
      params = this.$commonJs.obj.removeNullKey({ ...params })
      return new Promise((resolve, reject) => {
        this.getCompanies().then(() => {
          this.getManualCountInfo().then(() => {
            // params = { id: 2, orderNumber: "240315-483215317890992" };
            this[this.sysType + "Api"].order.getManual(params, this.mallId).then(res => {
              // console.log("getDataFunc", params)
              res.data = res.data.map(x => ({ ...x, isPrint: this.dataType })) // 测试
              resolve(res)
            }).catch(err => {
              resolve({ Code: 1, data: [] })
            })
          })
        })
      })
    },
    onCreate() {
      this.$refs.editDialog.openCreate().then(that => {
        that.setToken(this.mallId);
      });
    },
    onBatchCreate() {
      this.$refs.batchInsertDialog.open();
    },
    onTypeChange(e) {
      this.$refs.list.getData()
    },
    onAddressSelect(e) {
      console.log("111", e);
      // this.data.省市区文本 = e.map(x => x.label).join("/");
      // console.log("222", this.data.省市区);
      // console.log("333", this.data.省市区文本);
    },
    //批量回收单号
    batchRecycleNumber(data = null) {
      let rows = [];
      if (data) {
        rows = [data];
      } else {
        rows = this.$refs.list.getCheckedRows();
        if (rows.length == 0) {
          this.$message.warning("请选择数据");
          return;
        }
      }
      console.log("批量回收单号");
    },
    batchDelete(data = null) {
      let rows = [];
      if (data) {
        rows = [data];
      } else {
        rows = this.$refs.list.getCheckedRows();
        if (rows.length == 0) {
          this.$message.warning("请选择数据");
          return;
        }
      }
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var ids = rows.map(x => x.Id);
        console.log("删除", ids);
        this.reload();
      }).catch(() => { });
    },
    onExport() {
      this.$alert('导出订单', {
        confirmButtonText: '确定',
        callback: action => { }
      });
    },
    onEdit(data) {
      var obj = this.$platformJs.getPlatformObject(data);
      this.$refs.editDialog.openEdit(obj);
    },
    openPrint(data = null) {
      console.log("open", data)
      let rows = [];
      if (data) {
        rows = [data];
      } else {
        rows = this.$refs.list.getCheckedRows();
        if (rows.length == 0) {
          this.$message.warning("请选择数据");
          return;
        }
      }
      this.$refs.printDialog.open().then(that => {
        that.setData({ state: rows[0].Field5, isPrint: rows[0].isPrint, rows: rows });
      });
    },
    onRecycle(row) {
      var loading = this.$loading({
        lock: true,
        text: "正在回收...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      setTimeout(() => {
        loading.close();
        var data = { success: 3, error: [] }
        if (row.Id == 4) {
          data.error.push({
            no: "463448272394581",
            msg: "更新或取消面单失败，面单已经被揽收、签收、或回收",
          })
          this.$refs.recycleMsgDialog.open().then(that => {
            that.setData(data)
          });
        } else {
          var msg = `共计回收<span style="color: #67C23A;margin: 0 5px;">${data.success}</span>个。`
          this.$alert(msg, '回收成功', {
            confirmButtonText: '确定',
            dangerouslyUseHTMLString: true,
            callback: action => {
              this.reload();
            }
          });
        }
      }, 1000);
    },
    showPrint(id) {
      this.reload().then(res => {
        this.$refs.printDialog.open().then(that => {
          that.setDataById(id);
        });
      })
    }
  },
};
</script>
<style lang="scss"></style>